import { ActionsUnion, createAction } from 'spw-redux/types';
import { IProjectSpaceTypeCategory } from 'spw-redux/modules/projects/types';
import { CanDeleteEnum } from 'spw-shared/types';

export const UPDATE_PROJECT_SPACE_TYPE_CATEGORY =
  'projectSpaceTypeCategories/UPDATE_PROJECT_SPACE_TYPE_CATEGORY';
export const GET_PROJECT_SPACE_TYPE_CATEGORY_USAGE =
  'projectSpaceTypeCategories/GET_PROJECT_SPACE_TYPE_CATEGORY_USAGE';
export const SET_CAN_DELETE_SUBCATEGORY =
  'projectSpaceTypeCategories/SET_CAN_DELETE_SUBCATEGORY';
export const SET_ASSOCIATED_SPACE_TYPES_AND_WORKSHEETS =
  'projectSpaceTypeCategories/SET_ASSOCIATED_SPACE_TYPES_TYPES_AND_WORKSHEETS';
export const SET_ASSOCIATED_SPACE_TYPES_AND_FLOORPLANS =
  'projectSpaceTypeCategories/SET_ASSOCIATED_SPACE_TYPES_AND_FLOORPLANS';
export const DELETE_CUSTOM_SPACE_TYPE_SUBCATEGORIES =
  'projectSpaceTypeCategories/DELETE_CUSTOM_SPACE_TYPE_SUBCATEGORIES';

export const updateProjectSpaceTypeCategory = (
  spaceTypeCategory: IProjectSpaceTypeCategory,
  callback?: () => void
) =>
  createAction(UPDATE_PROJECT_SPACE_TYPE_CATEGORY, {
    spaceTypeCategory,
    callback,
  });

export const getProjectSpaceTypeCategoryUsage = (id: number) =>
  createAction(GET_PROJECT_SPACE_TYPE_CATEGORY_USAGE, { id });

export const setCanDeleteSubcategory = (canDelete: CanDeleteEnum) =>
  createAction(SET_CAN_DELETE_SUBCATEGORY, { canDelete });

export const setAssociatedSpaceTypesAndWorksheets = (
  associatedSpaceTypes: number,
  associatedWorksheets: number
) =>
  createAction(SET_ASSOCIATED_SPACE_TYPES_AND_WORKSHEETS, {
    associatedSpaceTypes,
    associatedWorksheets,
  });

export const setAssociatedSpaceTypesAndFloorplans = (
  associatedSpaceTypes: number,
  associatedFloorplans: number
) =>
  createAction(SET_ASSOCIATED_SPACE_TYPES_AND_FLOORPLANS, {
    associatedSpaceTypes,
    associatedFloorplans,
  });

export const deleteCustomSpaceTypeSubcategories = (
  categoryId: number,
  subcategoryIds: number[],
  callback?: () => void
) =>
  createAction(DELETE_CUSTOM_SPACE_TYPE_SUBCATEGORIES, {
    categoryId,
    subcategoryIds,
    callback,
  });

export const actions = {
  updateProjectSpaceTypeCategory,
  getProjectSpaceTypeCategoryUsage,
  setCanDeleteSubcategory,
  setAssociatedSpaceTypesAndWorksheets,
  setAssociatedSpaceTypesAndFloorplans,
  deleteCustomSpaceTypeSubcategories,
};

export type Actions = ActionsUnion<typeof actions>;
